import { Grid, Typography } from "@mui/material"
import React from "react"
import styles from "./UsageMatricsTable.module.scss"

const UserCategoryCard = ({ title, selectedOption, onSelect }) => {
  return (
    <div style={{ position: "relative", display: "flex" }}>
      <Grid
        item
        className={`${styles.container} ${selectedOption && styles.withBoxShadow}`}
        onClick={onSelect}>
        <Typography variant="caption5" sx={{ padding: "4px 16px" }}>
          {title}
        </Typography>
      </Grid>
    </div>
  )
}

export default UserCategoryCard
